import React from "react";
import { useTheme } from "../../components/context/context";

function PageNotFound() {
  const {fontSize} = useTheme();
  return (
    <div style={style.container}>
      <h1 style={{fontSize:`${fontSize+3}rem`}}>Page Not Found</h1>
    </div>
  );
}

export default PageNotFound;

const style = {
  container: {
    width:"100%",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    alignItems: "center",
    gap: 4,
  },
};
